import { render, staticRenderFns } from "./KLiveMatches.vue?vue&type=template&id=31aae010&scoped=true&"
import script from "./KLiveMatches.vue?vue&type=script&lang=ts&"
export * from "./KLiveMatches.vue?vue&type=script&lang=ts&"
import style0 from "./KLiveMatches.vue?vue&type=style&index=0&id=31aae010&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aae010",
  null
  
)

export default component.exports